import { LayoutTree } from "../components/controls/layout.tree";

export const APP_DECLARATIONS = [
    LayoutTree
];
